{
  "features": {
    "config": {
      "title": "Begleiter des Lamms",
      "subtitle": "Twitch-Einbindung-Konfiguration",
      "sections": {
        "premiumSkins": {
          "title": "Premium-Skins",
          "description": "Mit dieser Erweiterung können Zuschauer im Spiel als Anhänger erscheinen. Sie können ihre Anhänger anpassen, einschließlich der Nutzung von Bits für Premium-Skins. Du kannst entscheiden, wie viele Bits sie kosten sollen, oder sie zur freien Nutzung für alle kostenlos anbieten.",
          "noBitsOption": "Keine Bits für Premium-Skins verlangen",
          "bitsFeatureNotAvailable": "Dein Kanal kann keine Bits verwenden. Deine Zuschauer können jede Skin verwenden, ohne dafür Bits zu zahlen."
        }
      },
      "actions": {
        "save": "Änderungen speichern"
      }
    },
    "followers": {
      "rafflePopup": {
        "title": "Tritt dem Kult von {{channelName}} bei!",
        "subtitle": "Du hast die Ziehung gewonnen!",
        "timeRemaining": "Verbleibende Zeit: {{time}}",
        "message": "Unserem Kult beizutreten, hat eine Menge Vorteile: die Chance auf zusätzliche dämonische Gliedmaßen, die Ehre, jede Sekunde seines Lebens dem Kult des Lamms zu widmen, und der Ruhm, womöglich als Opfer zu dienen!",
        "viewerLinkCta": "Um beizutreten: {Identität mitteilen}",
        "actions": {
          "joinRaffle": "Ich möchte dem Kult beitreten.",
          "joinRaffleViewerHasAlreadyJoined": "Du bist der Ziehung beigetreten.",
          "dismissRaffle": "Nein danke, ist nichts für mich.",
          "dismissRaffleViewerHasAlreadyJoined": "Schließen"
        },
        "raffleJoinedMessage": "Deine Bereitwilligkeit ist löblich. Solltest du auserwählt werden, dem Kult beizutreten, wirst du in Kürze informiert. Du kannst dieses Fenster schließen."
      },
      "followerBuilder": {
        "title": "Deinen Anhänger erstellen",
        "steps": {
          "intro": {
            "message": "Du bist dem Kult beigetreten! Der Anhänger, den du hier erstellst, wird im Spiel erscheinen. Denk daran, dass er irgendwann sterben wird – aber wenigstens im Dienste einer großen Sache.",
            "actions": {
              "goToNextStep": "Deinen Anhänger erstellen"
            }
          },
          "skinSelection": {
            "actions": {
              "goToNextStep": "Weiter"
            }
          },
          "colorSelection": {
            "actions": {
              "goToPreviousStep": "Zurück zu den Skins",
              "goToNextStep": {
                "variationsForSkin": "Weiter",
                "noVariationsForSkin": "Meinen Anhänger erstellen"
              }
            }
          },
          "variationSelection": {
            "actions": {
              "goToPreviousStep": "Zurück zu den Farben",
              "goToNextStep": "Meinen Anhänger erstellen"
            }
          }
        }
      }
    },
    "helpOrHinder": {
      "help": "helfen",
      "hinder": "hindern",
      "hhVotingFlyout": {
        "title": "Helfen oder Hindern",
        "message": "Stimme abgeben",
        "timeRemaining": "Verbleibende Zeit: {{time}}",
        "voteCount": "Stimmen: {{amount}}"
      },
      "outcomeVotingFlyout": {
        "title": "Gib deine Stimme ab, um {{channelName}} zu {{helpOrHinder}}.",
        "timeRemaining": "Verbleibende Zeit: {{time}}"
      }
    }
  }
}
